import { IconMaximizeCustom } from '../../setup/settings';
import iconMaximizeClose from '../assets/icons/IconMaximizeClose.png';
import iconMaximizeExpand from '../assets/icons/IconMaximizeExpand.png';
import { useEffect, useState } from 'react';
export default function Maximize()
{
    
    const [icon, setIcon] = useState(!IconMaximizeCustom.active? iconMaximizeExpand :IconMaximizeCustom.iconMaximizeExpand );

    function toggleFullScreen() {
        if ((document.fullScreenElement && document.fullScreenElement !== null) ||
            (!document.mozFullScreen && !document.webkitIsFullScreen)) 
        {
            if (document.documentElement.requestFullScreen) 
            {
                document.documentElement.requestFullScreen();
            } 
            else if (document.documentElement.mozRequestFullScreen) 
            {
                document.documentElement.mozRequestFullScreen();
            } 
            else if (document.documentElement.webkitRequestFullScreen) 
            {
                document.documentElement.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT);
            }
        } 
        else 
        {
            if (document.cancelFullScreen) 
            {
                document.cancelFullScreen();
            } 
            else if (document.mozCancelFullScreen) 
            {
                document.mozCancelFullScreen();
            } else if (document.webkitCancelFullScreen) 
            {
                document.webkitCancelFullScreen();
            }
        }
    }
    
    const changeIcon =  ({height} : any) => 
    {
        try 
        {
            if (document != null  && document.fullscreenElement == null )
            {
                setIcon(!IconMaximizeCustom.active? iconMaximizeExpand :IconMaximizeCustom.iconMaximizeExpand );
                
            }
            else if (  typeof window !== 'undefined' && height == window.screen.height)
            {

                setIcon(!IconMaximizeCustom.active? iconMaximizeExpand :IconMaximizeCustom.iconMaximizeExpand );
                
            }
            else
            {
                setIcon(!IconMaximizeCustom.active? iconMaximizeClose :IconMaximizeCustom.iconMaximizeClose );
            }
        }
        catch (error)
        {
            setIcon(!IconMaximizeCustom.active? iconMaximizeExpand :IconMaximizeCustom.iconMaximizeExpand );
        }
    }


    const [breakpoint, setBreakpoint] = useState(() => changeIcon(typeof window !== 'undefined' && (window.innerHeight)));
    
    useEffect(() => 
    {
        if (typeof window !== 'undefined') 
        {
            const detectChangesScreen = function() 
            {
                setBreakpoint(changeIcon(window.innerHeight));
            }
            window.addEventListener('resize', detectChangesScreen);
            return () => window.removeEventListener('resize', detectChangesScreen);
        }
    }, [])
    
    const Maximize =  () => 
    {
        try 
        {
            if (document.fullscreenElement == null){
                toggleFullScreen();
            }
            else{
                toggleFullScreen();
            }
        }
        catch (error)
        {
            console.log(error);
        }
    }


   return(
    <div className='maximize-div' >
        <a className="maximize-a" onClick={Maximize}>
            <img className='maximize-close' src={icon}></img>
        </a>
    </div>
   )
}